import { useSession } from 'next-auth/react';
import { LanguagesEnum } from 'abi-genome-common-types';

import { useUserAbilities } from '~/shared/hooks/useUserAbilities';

export function useUser() {
  const { data: session } = useSession();
  const { data: abilitiesData } = useUserAbilities();
  const px = session?.user?.px;

  return {
    name: px?.name ?? session?.user.name,
    email: px?.email ?? session?.user.email,
    zone: px?.zone ?? session?.user.zone,
    globalId: px?.gid ?? session?.user.gid,
    employeeId: px?.uid ?? session?.user.uid,
    language: session?.user.lcl as keyof typeof LanguagesEnum,
    band: px?.band ?? session?.user.band,
    isProxied: Boolean(px),
    isApprover: Boolean(
      px?.isApprover ??
        session?.user.isApprover ??
        px?.isAdmin ??
        session?.user.isAdmin
    ),
    isAdmin: Boolean(px?.isAdmin ?? session?.user.isAdmin),
    isCountryAdmin: Boolean(session?.user.isCountryAdmin),
    isZoneAdmin: Boolean(session?.user.isZoneAdmin),
    canAccessScopedAdmin: Boolean(
      session?.user.isCountryAdmin || session?.user.isZoneAdmin
    ),
    canAccessApprovalConfiguration: Boolean(
      (px?.isAdmin ?? session?.user.isAdmin) ||
        session?.user.isCountryAdmin ||
        session?.user.isZoneAdmin
    ),
    hasVisibleApprovals: Boolean(
      px?.hasVisibleApprovals ?? session?.user.hasVisibleApprovals
    ),
    roles: abilitiesData?.role,
    managedZones: abilitiesData?.zones,
    currentTeamName: abilitiesData?.currentTeamName,
    currentTeamCanApprove: abilitiesData?.currentTeamCanApprove,
    adminName: session?.user.name,
  };
}

export type User = ReturnType<typeof useUser>;
